import { render, staticRenderFns } from "./CompaniesSearch.vue?vue&type=template&id=d8d36ba4&"
import script from "./CompaniesSearch.vue?vue&type=script&lang=js&"
export * from "./CompaniesSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports